import React from 'react';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import './CTASection.css';

interface CTAAction {
  label: string;
  to: string;
  variant?: 'primary' | 'secondary';
}

interface CTASectionProps {
  eyebrow?: string;
  title: string;
  actions: CTAAction[];
}

const CTASection: React.FC<CTASectionProps> = ({ eyebrow, title, actions }) => {
  return (
    <section className="consulting-cta">
      <div className="container">
        {eyebrow && <p className="cta-eyebrow">{eyebrow}</p>}
        <h2 className="cta-title">{title}</h2>
        <div className="cta-actions">
          {actions.map((action) => (
            <Button
              key={action.label}
              component={Link}
              to={action.to}
              variant={action.variant === 'secondary' ? 'outlined' : 'contained'}
              size="large"
            >
              {action.label}
            </Button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CTASection;
